var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWemix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 2.56055C8.57868 2.56055 2.56055 8.57868 2.56055 16.0005C2.56055 16.804 2.63521 17.5894 2.76961 18.3525H5.75404C6.13558 18.3525 6.36406 18.2286 6.5119 17.9897L7.56022 16.2529L8.90124 20.4171C9.0334 20.8359 9.34476 21.054 9.76438 21.057C10.1945 21.0592 10.5491 20.7956 10.6328 20.3655L11.6057 15.7803L12.6644 23.0916C12.7294 23.5725 12.9631 23.8144 13.4469 23.8144H13.4522C13.9338 23.8144 14.1645 23.5538 14.2317 23.0752L16.3903 8.84524C16.4195 8.6332 16.3634 8.41826 16.2343 8.24751C16.1053 8.07675 15.9138 7.96412 15.7019 7.9343C15.4901 7.90594 15.2757 7.96223 15.1051 8.09098C14.9346 8.21972 14.8217 8.41052 14.7909 8.62198L13.4604 17.7448L12.5651 11.6564C12.5061 11.189 12.1515 10.8986 11.764 10.8904C11.3264 10.8799 11.0009 11.1539 10.9098 11.6191L9.62401 17.576L8.59734 14.3803C8.55498 14.2118 8.46276 14.06 8.33274 13.9448C8.20272 13.8295 8.04096 13.7562 7.8686 13.7344C7.40118 13.6784 7.13462 13.9203 6.93825 14.2399L5.35084 16.7397H4.40183C4.38477 16.4937 4.3758 16.2472 4.37495 16.0005C4.37495 9.57921 9.57921 4.37495 16.0005 4.37495C21.1779 4.37495 25.5646 7.76182 27.0669 12.4389H28.9597C27.3976 6.74561 22.1904 2.56055 16.0005 2.56055Z",
    fill: "url(#paint0_linear_57758_38069)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2311 13.6494H26.2414C25.8599 13.6494 25.6314 13.7733 25.4836 14.0122L24.4352 15.749L23.0935 11.5848C22.9621 11.166 22.65 10.9479 22.2311 10.9449C21.801 10.9427 21.4463 11.2063 21.3627 11.6364L20.3898 16.2216L19.3303 8.91027C19.2661 8.42942 19.0316 8.1875 18.5485 8.1875H18.5433C18.0617 8.1875 17.831 8.44809 17.7638 8.9267L15.6044 23.1567C15.5424 23.5972 15.8516 24.0064 16.2921 24.0676C16.5039 24.096 16.7183 24.0397 16.8889 23.9109C17.0594 23.7822 17.1723 23.5914 17.203 23.3799L18.5343 14.2571L19.4296 20.3455C19.4886 20.8129 19.8432 21.1033 20.23 21.1115C20.6683 21.122 20.9939 20.848 21.0849 20.3828L22.37 14.4259L23.3966 17.6216C23.4773 17.9688 23.7864 18.2264 24.1254 18.2675C24.5928 18.3235 24.8593 18.0816 25.055 17.762L26.6439 15.2622H27.5981C27.6145 15.5071 27.625 15.7542 27.625 16.0014C27.625 22.4227 22.4207 27.627 15.9994 27.627C10.822 27.627 6.43536 24.2401 4.93307 19.563H3.04102C4.60304 25.2563 9.81253 29.4414 16.0002 29.4414C23.422 29.4414 29.4401 23.4232 29.4401 16.0014C29.4401 15.1979 29.3655 14.4125 29.2311 13.6494Z",
    fill: "url(#paint1_linear_57758_38069)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57758_38069",
    x1: 2.56055,
    y1: 2.56055,
    x2: 29.4405,
    y2: 29.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC829F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#FF1C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#EA49F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#B250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#5E5FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57758_38069",
    x1: 2.56016,
    y1: 2.56137,
    x2: 29.4401,
    y2: 29.4414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC829F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#FF1C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#EA49F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#B250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#5E5FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWemix);
export default __webpack_public_path__ + "static/media/wemix.cb08be1b0a41ff7b9559856ae69f3703.svg";
export { ForwardRef as ReactComponent };